$(function() {
    var labels = {
        'incoming_call': document.querySelector('meta[name=incoming_call]').content,
        'answer': document.querySelector('meta[name=answer]').content,
        'reject': document.querySelector('meta[name=reject]').content,
        'from': document.querySelector('meta[name=from]').content,
        'to': document.querySelector('meta[name=to]').content,
    };

    var audioElement = {
        phoneCall: null
    };

    $('[data-init-call]').each(function() {
        var deviceCode = $('[name=device-code]').attr('content');

        if (deviceCode == '0')
            return;

        var myPeer = new Peer(deviceCode, {
            host: 'app.idicare.com',
            secure: true,
            port: 443,
            path: '/peerjs',
            config: {
                'iceServers': [
                    { url: 'stun:stun01.sipphone.com' },
                    { url: 'stun:stun.ekiga.net' },
                    { url: 'stun:stun.fwdnet.net' },
                    { url: 'stun:stun.ideasip.com' },
                    { url: 'stun:stun.iptel.org' },
                    { url: 'stun:stun.rixtelecom.se' },
                    { url: 'stun:stun.schlund.de' },
                    { url: 'stun:stun.l.google.com:19302' },
                    { url: 'stun:stun1.l.google.com:19302' },
                    { url: 'stun:stun2.l.google.com:19302' },
                    { url: 'stun:stun3.l.google.com:19302' },
                    { url: 'stun:stun4.l.google.com:19302' },
                    { url: 'stun:stunserver.org' },
                    { url: 'stun:stun.softjoys.com' },
                    { url: 'stun:stun.voiparound.com' },
                    { url: 'stun:stun.voipbuster.com' },
                    { url: 'stun:stun.voipstunt.com' },
                    { url: 'stun:stun.voxgratia.org' },
                    { url: 'stun:stun.xten.com' },
                    {
                        url: 'turn:numb.viagenie.ca',
                        credential: 'muazkh',
                        username: 'webrtc@live.com'
                    },
                    {
                        url: 'turn:192.158.29.39:3478?transport=udp',
                        credential: 'JZEOEt2V3Qb0y27GRntt2u2PAYA=',
                        username: '28224511:1379330808'
                    },
                    {
                        url: 'turn:192.158.29.39:3478?transport=tcp',
                        credential: 'JZEOEt2V3Qb0y27GRntt2u2PAYA=',
                        username: '28224511:1379330808'
                    }
                ]
            }
        });

        myPeer.on('call', call => {
            console.log(call);
            showIncomingCall(call).then(function(response) {
                // window.location.href = '/telemedicine/' + response.code + '-' + response.node;
            }, function() {
                // rejected call
            });
        });
    });

    function getAudioPhoneCall() {
        if (audioElement.phoneCall == null) {
            var audioElement0 = document.createElement('audio');
            audioElement0.setAttribute('src', '/assets/audio/phonecall.mp3');
            audioElement0.setAttribute('autoplay', 'autoplay');
            audioElement0.setAttribute('loop', 'loop');
            audioElement.phoneCall = audioElement0;
        }
        return audioElement.phoneCall;
    }

    function showIncomingCall(call) {
        return new Promise(function(resolve, reject) {
            var $elem = createElement(
                call.metadata.callId,
                call.metadata.node2,
                call.metadata.node1Picture,
                call.metadata.node1Color,
                call.metadata.node1NameLetter,
                call.metadata.node1Name,
                call.metadata.patientPicture,
                call.metadata.patientColor,
                call.metadata.patientNameLetter,
                call.metadata.patientName
            );

            var phoneCall = getAudioPhoneCall();
            phoneCall.play();

            $elem.on('click', 'a[data-ok]', function(e) {
                e.preventDefault();
                resolve({
                    code: call.metadata.callId,
                    node: call.metadata.node2
                });
                remove();
                return false;
            });

            $elem.on('click', 'a[data-cancel]', function(e) {
                e.preventDefault();
                reject();
                remove();
                return false;
            });

            $(document.body).append($elem);
            function remove() {
                phoneCall.pause();
                phoneCall.currentTime = 0;
                $elem.remove();
            }
        });
    }

    function createElement(code, node, node1Picture, node1Color, node1NameLetter, node1Name, node2Picture, node2Color, node2NameLetter, node2Name) {
        return $([
            '<div class="incoming-call">',
                '<div>',
                    '<h1 class="incoming-call__title">', labels.incoming_call, '</h1>',
                    '<div class="incoming-call__elements">',
                        createCallElement(labels.from, node1Picture, node1Color, node1NameLetter, node1Name),
                        createCallElement(labels.to, node2Picture, node2Color, node2NameLetter, node2Name),
                    '</div>',
                    '<div class="incoming-call__actions">',
                        '<a class="focusable focusable--is-level-2 button" href="/telemedicine/', code, '-', node, '">', labels.answer, '</a>',
                        '<a class="focusable focusable--is-level-2 button" href="#" data-no-loading data-cancel>', labels.reject, '</a>',
                    '</div>',
                '</div>',
            '</div>'
        ].join(''));
    }

    function createCallElement(label, nodePicture, nodeColor, nodeNameLetter, nodeName) {
        if (!nodeName) {
            return '';
        }
        return [
            '<div class="incoming-call__element">',
                '<span class="incoming-call__subtitle">', label, '</span>',
                createPictureElement(nodePicture, nodeColor, nodeNameLetter),
                '<span class="incoming-call__name">', nodeName, '</span>',
            '</div>'
        ].join('');
    }

    function createPictureElement(nodePicture, nodeColor, nodeNameLetter) {
        if (nodePicture) {
            return [
                '<div class="picture picture--has-size-l" style="', nodeColor, '">',
                    '<picture>',
                        '<source srcset="/files/image/', nodePicture, '/227/">',
                        '<img src="/files/image/', nodePicture, '/227/">',
                    '</picture>',
                '</div>'
            ].join('');
        }
        return [
            '<div class="picture picture--has-size-l" style="', nodeColor, '">', nodeNameLetter, '</div>',
        ].join('');
    }

    // showIncomingCall({metadata: {
    //     callId: 1,
    //     node2: 1,

    //     node1Picture: null,
    //     node1Color: 'background-color: hsl(47, 100%, 49%); color: hsl(47, 100%, 29%)',
    //     node1NameLetter: 'TI',
    //     node1Name: 'Teste Idicare',

    //     patientPicture: null,
    //     patientColor: 'background-color: hsl(87, 100%, 49%); color: hsl(87, 100%, 29%)',
    //     patientNameLetter: 'IP',
    //     patientName: 'Idicare PT'
    // }});
});

